import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import toast from "react-hot-toast";
import writeXlsxFile from "write-excel-file";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { AdminFilter } from "utils/helperComponent";
import {
  Button,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import {
  getAllPJPstats,
  getAllVisitsData,
  getLeadStats,
  getCallOptData,
  getCpmDataMonthly,
  getRegionsByZone,
  getAttendanceData,
  getROCallOptData,
  getROCpmDataMonthly,
  getTPReport,
  getCallOptDataDailyRO,
} from "_controllers/officer";
import dotenv from "dotenv";
import { useHistory } from "react-router-dom";
import { basicAuth } from "setups/axios";
import exportExcel from "utils/excelGenerate";
import moment from "moment";
import { useSelector } from "react-redux";
import haversine from "haversine-distance";
import { attendanceDataExcel, transmissionData, transmissionDataRO } from "utils/helper";
import axios from "axios";
import { PageHeader, SectionCard } from "_shared/ui";

dotenv.config();

// Themed date picker used by every report row. Native <input type="date">
// replaced with an MUI TextField so it inherits the theme (dark-safe, square).
const DateInput = ({ value, onChange }) => (
  <TextField
    type="date"
    size="small"
    value={value}
    onChange={onChange}
    InputLabelProps={{ shrink: true }}
    sx={{ minWidth: 160 }}
  />
);

const Main = () => {
  const navigate = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [appliedFilter, setAppliedFilter] = useState(false);

  const [SAP, setSAP] = useState("");
  const [downloadReady, setDownloadReady] = useState(false);

  const [timeSpentStartDate, setTimeSpentStartDate] = useState("");
  const [timeSpentEndDate, setTimeSpentEndDate] = useState("");
  const [timeSpentData, setTimeSpentData] = useState("");

  const [callOptStartDate, setCallOptStartDate] = useState("");
  const [callOptEndDate, setCallOptEndDate] = useState("");
  const [isCallOptGenerated, setIsCallOptGenerated] = useState(false);
  const [callOptData, setCallOptData] = useState();

  
  const [ROCallOptStartDate, setROCallOptStartDate] = useState("");
  const [ROCallOptEndDate, setROCallOptEndDate] = useState("");
  const [isROCallOptGenerated, setIsROCallOptGenerated] = useState(false);
  const [ROCallOptData, setROCallOptData] = useState();

  const [attendanceData, setAttendanceData] = useState();
  const [attendanceStartDate, setattendanceStartDate] = useState("");
  const [attendanceEndDate, setattendanceEndDate] = useState("");
  const [isAttedanceGenerated, setIsAttedanceGenerated] = useState(false);

  const [cpmStartDate, setCpmStartDate] = useState("");
  const [cpmEndDate, setCpmEndDate] = useState("");
  const [isCpmGenerated, setIsCpmGenerated] = useState(false);
  const [cpmData, setCpmData] = useState([]);

  const [ROCpmStartDate, setROCpmStartDate] = useState("");
  const [ROCpmEndDate, setROCpmEndDate] = useState("");
  const [isROCpmGenerated, setIsROCpmGenerated] = useState(false);
  const [ROCpmData, setROCpmData] = useState([]);


  const [loadingOptReportRO, setLoadingOptReportRO] = useState(false);
  const [disableOptReportROButton, setDisableOptReportROButton] = useState(true);
  const [OptReportROStartDate, setOptReportROStartDate] = useState("");
  const [OptReportROEndDate, setOptReportROEndDate] = useState("");
  const [isOptReportROGenerated, setIsOptReportROGenerated] = useState(false);
  const [OptReportROData, setOptReportROData] = useState();

  const [uniqueHitsStartDate, setUniqueHitsStartDate] = useState("");
  const [uniqueHitsEndDate, setUniqueHitsEndDate] = useState("");
  const [downloadCheckTime, setDownloadCheckTime] = useState(false);

  const [loadingVisits, setLoadingVisits] = useState(false);
  const [loadingTimeSpent, setLoadingTimeSpent] = useState(false);
  const [loadingPJP, setLoadingPJP] = useState(false);
  const [loadingLeads, setLoadingLeads] = useState(false);
  const [loadingCallOpt, setLoadingCallOpt] = useState(false);
  const [loadingROCallOpt, setLoadingROCallOpt] = useState(false);
  const [loadingCpm, setLoadingCpm] = useState(false);
  const [loadingROCpm, setLoadingROCpm] = useState(false);
  const [loadingAttendance, setLoadingAttendance] = useState(false);

  const [disableButton, setDisableButton] = useState(true);
  const [disableTimeButton, setDisableTimeButton] = useState(true);
  const [disablePJPButton, setDisablePJPButton] = useState(true);
  const [disableLeadsButton, setDisableLeadsButton] = useState(true);
  const [disableCallOptButton, setDisableCallOptButton] = useState(true);
  const [disableROCallOptButton, setDisableROCallOptButton] = useState(true);
  const [disableCpmButton, setDisableCpmButton] = useState(true);
  const [disableROCpmButton, setDisableROCpmButton] = useState(true);
  const [disableAttendanceButton, setDisableAttendanceButton] = useState(true);

  const [visitData, setVisitData] = useState([]);
  const [visitsStartDate, setVisitsStartDate] = useState("");
  const [visitsEndDate, setVisitsEndDate] = useState("");

  const [pjpData, setPjpData] = useState([]);
  const [isPJPGenerated, setIsPJPGenerated] = useState(false);
  const [pjpStartDate, setPjpStartDate] = useState("");
  const [pjpEndDate, setPjpEndDate] = useState("");

  const [leadsData, setLeadsData] = useState([]);
  const [downloadCheckLeads, setDownloadCheckLeads] = useState(false);
  const [leadsStartDate, setLeadsStartDate] = useState("");
  const [leadsEndDate, setLeadsEndDate] = useState("");

  const [regionsCode, setRegionsCode] = useState();
  const [filterLoading, setFilterLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

////////////////////SOSummary
  const [disableSOSummaryButton, setdisableSOSummaryButton] = useState(true);
  const [loadingSOSummary, setLoadingSOSummary] = useState(false);
  const [SOSummaryData, setSOSummaryData] = useState();
  const [SOSummaryEndDate, setSOSummaryEndDate] = useState("");
  const [SOSummaryStartDate, setSOSummaryStartDate] = useState("");
  const [isSOSummaryGenerated, setSOSummaryGenerated] = useState(false);

  /////////////////////travelplan report

  
  const [tpStartDate, settpStartDate] = useState("");
  const [tpEndDate, settpEndDate] = useState("");
  const [istpGenerated, setistpGenerated] = useState(false);
  const [loadingtp, setLoadingtp] = useState(false);
  const [disabletpButton, setDisabletpButton] = useState(true);
  const [tpData, settpData] = useState([]);

  useEffect(() => {
    if (tpStartDate && tpEndDate) {
      const start = new Date(tpStartDate);
      const end = new Date(tpEndDate);
      const differenceInDays = Math.floor(
        (end - start) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays > 365) {
        return toast.error(
          "Date range should be less then of equal to 1 year (365 days).",
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
      return setDisabletpButton(false);
    }
  }, [tpStartDate, tpEndDate]);

  const generatetpCSV = async (filter) => {
    if(new Date(tpEndDate)<new Date(tpStartDate)){
      return toast.error(
        "End Date can not be Smaller than Start Date.",
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
    setLoadingtp(true);
    setDisabletpButton(true);
    await getTPReport({
      start: tpStartDate,
      end: tpEndDate,
    })
      .then((data) => {
        console.log("🚀 ~ file: index.js:625 ~ data:", data.travelPlans);
        settpData(data?.travelPlans);
        setLoadingtp(false);
        setistpGenerated(true);
        setDisabletpButton(false);
      })
      .catch((err) => {
        setLoadingtp(false);
        setDisabletpButton(true);
        return toast.error(err.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      });
  };
  const downloadtpCSV = async () => {
    let from = tpStartDate.split("T")[0];
    let to = tpEndDate.split("T")[0];
    const tpFileName = `Travel_Plan-from_${from}_to_${to}_`;
    let tpArray = await tpData?.map((obj) => {
      console.log("newobj", obj);
      let newObj = {
        SAP_ID:obj.createdBy.SAP_ID,
        Designation:obj.createdBy.role,
        Location:obj.createdBy.role==="RO" || obj.createdBy.role==="ZO"?obj.createdBy.regionName: `Latitude:${obj.startinglocation.latitude} , Longitude:${obj.startinglocation.longitude}`,   
        Date:obj.dateofTravelPlan.split("T")[0],
        "Travel Plan":obj.travelPlan.plan,
        Remarks:obj.travelPlan.details

      };
      return newObj;
    });
    if (tpArray && tpArray.length) {
      let emparr = {};
      tpArray.push(emparr);
      // console.log("comap", tpArray);
      exportExcel(tpArray, tpFileName);
      setistpGenerated(false);
      setDisabletpButton(false);
      setLoadingtp(false);
    } else {
      return toast.error("No Data found to download.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };
  ///////////////////////////
  const { user } = useSelector((state) => state.user);
  const { role, SAP_ID } = user;
  const filterDropDown = {
    zone: [""],
  };

  const calculateDistance = (coordinates) => {
    const { lat1, long1, lat2, long2 } = coordinates;
    const distance = haversine(
      { lat: lat1, lng: long1 },
      { lat: lat2, lng: long2 }
    );
    return isNaN(distance) ? "NA" : distance.toFixed(0);
  };

  useEffect(() => {
    if (visitsStartDate && visitsEndDate) {
      setDisableButton(false);
    }
  }, [visitsStartDate, visitsEndDate]);
  useEffect(() => {
    if (timeSpentStartDate && timeSpentEndDate) {
      setDisableTimeButton(false);
    }
  }, [timeSpentStartDate, timeSpentEndDate]);
  useEffect(() => {
    if (pjpStartDate && pjpEndDate) {
      setDisablePJPButton(false);
    }
  }, [pjpStartDate, pjpEndDate]);
  useEffect(() => {
    if (leadsStartDate && leadsEndDate) {
      setDisableLeadsButton(false);
    }
  }, [leadsStartDate, leadsEndDate]);
  useEffect(() => {
    if (attendanceStartDate && attendanceEndDate) {
      setDisableAttendanceButton(false);
    }
  }, [attendanceStartDate, attendanceEndDate]);
  useEffect(() => {
    if (callOptStartDate && callOptEndDate) {
      const start = new Date(callOptStartDate);
      const end = new Date(callOptEndDate);
      const differenceInDays = Math.floor(
        (end - start) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays <= 31) {
        return setDisableCallOptButton(false);
      }
      return toast.error(
        "Date range should be less then or equal to 31 days.",
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
  }, [callOptStartDate, callOptEndDate]);
  useEffect(() => {
    if (ROCallOptStartDate && ROCallOptEndDate) {
      const start = new Date(ROCallOptStartDate);
      const end = new Date(ROCallOptEndDate);
      const differenceInDays = Math.floor(
        (end - start) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays <= 31) {
        return setDisableROCallOptButton(false);
      }
      return toast.error(
        "Date range should be less then or equal to 31 days.",
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
  }, [ROCallOptStartDate, ROCallOptEndDate]);
  useEffect(() => {
    if (cpmStartDate && cpmEndDate) {
      const start = new Date(cpmStartDate);
      const end = new Date(cpmEndDate);
      const differenceInDays = Math.floor(
        (end - start) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays > 365) {
        return toast.error(
          "Date range should be less then of equal to 1 year (365 days).",
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
      return setDisableCpmButton(false);
    }
  }, [cpmStartDate, cpmEndDate]);
  useEffect(() => {
    if (ROCpmStartDate && ROCpmEndDate) {
      const start = new Date(ROCpmStartDate);
      const end = new Date(ROCpmEndDate);
      const differenceInDays = Math.floor(
        (end - start) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays > 365) {
        return toast.error(
          "Date range should be less then of equal to 1 year (365 days).",
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
      return setDisableROCpmButton(false);
    }
  }, [ROCpmStartDate, ROCpmEndDate]);
  useEffect(() => {
    if (OptReportROStartDate && OptReportROEndDate) {
      const start = new Date(OptReportROStartDate);
      const end = new Date(OptReportROEndDate);
      const differenceInDays = Math.floor(
        (end - start) / (1000 * 60 * 60 * 24)
      );
      if (differenceInDays > 31) {
        return toast.error(
          "Date range should be less then or equal to 31 days",
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
      }
      return setDisableOptReportROButton(false);
    }
  }, [OptReportROStartDate, OptReportROEndDate]);


  const generateVisitCSV = async () => {
    setLoadingVisits(true);
    setDisableButton(true);
    await getAllVisitsData({
      start: visitsStartDate,
      end: visitsEndDate,
    })
      .then((data) => {
        setVisitData(data?.data);
        setDownloadReady(true);
        setLoadingVisits(false);
        setDisableButton(false);
      })
      .catch((err) => console.log("error", err));
  };

  const handleVisits = async () => {
    setLoadingVisits(true);
    setDisableButton(true);
    let data = [];
    let timeSpent = (start, end) => {
      return moment.duration(end.diff(start));
    };
    for await (let d of visitData) {
      let secVisitCoordinates = {
        lat1: d?.startLat ? d?.startLat : 0,
        long1: d?.startLong ? d?.startLong : 0,
        lat2: d?.endLat ? d?.endLat : 0,
        long2: d?.endLong ? d?.endLong : 0,
      };
      switch (d?.visitType) {
        case "CUSTOMERS":
          let obj = {};
          obj["SAP_ID"] = d?.SAP_ID;
          obj["Zone"] = d?.userDetails?.zone;
          obj["Region"] = d?.userDetails?.region;
          obj["Area"] = d?.userDetails?.area;
          obj["Territory"] = d?.userDetails?.territory;
          obj["Category"] = d?.visitType;
          obj["Dealer Code"] = "NA";
          obj["Dealer Name"] = d?.dealerName;
          obj["On Date"] = moment.utc(d?.startTime).format("YYYY-MM-DD");
          obj["Start Time"] = moment.utc(d?.startTime).format("HH:mm");
          obj["End Time"] = d?.endTime
            ? moment.utc(d?.endTime).format("HH:mm")
            : "NA";
          obj["Time Spent (in mins)"] = timeSpent(
            moment(d?.startTime ? d?.startTime : ""),
            moment(d?.endTime ? d?.endTime : "")
          )
            .asMinutes()
            .toFixed(0);
          obj["Start Location"] = `Lat: ${d?.startLat}, Long: ${d?.startLong} `;
          obj["End Location"] = `Lat: ${d?.endLat}, Long: ${d?.endLong} `;
          (obj["Visit Type"] =
            d?.unplanned === false ? "Planned" : "UnPlanned"),
            (obj["Distance Flag"] =
              calculateDistance(secVisitCoordinates) === "NA"
                ? "NA"
                : calculateDistance(secVisitCoordinates) < 100
                ? "< 100 m"
                : ">100 m");
          (obj["Completed"] = d?.completed === false ? "False" : "True"),
            (obj["Remark"] = d?.remark);
          data.push(obj);
          break;

        case "PROSPECTS":
          let obj1 = {};
          obj1["SAP_ID"] = d?.SAP_ID;
          obj1["Zone"] = d?.userDetails?.zone;
          obj1["Region"] = d?.userDetails?.region;
          obj1["Area"] = d?.userDetails?.area;
          obj1["Territory"] = d?.userDetails?.territory;
          obj1["Category"] = d?.visitType;
          obj1["Dealer Code"] = "NA";
          obj1["Dealer Name"] = d?.dealerName;
          obj1["On Date"] = moment.utc(d?.startTime).format("YYYY-MM-DD");
          obj1["Start Time"] = moment.utc(d?.startTime).format("HH:mm");
          obj1["End Time"] = d?.endTime
            ? moment.utc(d?.endTime).format("HH:mm")
            : "NA";
          obj1["Time Spent (in mins)"] = timeSpent(
            moment(d?.startTime ? d?.startTime : ""),
            moment(d?.endTime ? d?.endTime : "")
          )
            .asMinutes()
            .toFixed(0);
          obj1[
            "Start Location"
          ] = `Lat: ${d?.startLat}, Long: ${d?.startLong} `;
          obj1["End Location"] = `Lat: ${d?.endLat}, Long: ${d?.endLong} `;
          (obj1["Visit Type"] =
            d?.unplanned === false ? "Planned" : "UnPlanned"),
            (obj1["Distance Flag"] =
              calculateDistance(secVisitCoordinates) === "NA"
                ? "NA"
                : calculateDistance(secVisitCoordinates) < 100
                ? "< 100 m"
                : ">100 m");
          (obj1["Completed"] = d?.completed === false ? "False" : "True"),
            (obj1["Remark"] = d?.remark);
          data.push(obj1);
          break;

        case "INFLUENCER":
        case "INFLUENCERS":
          let obj2 = {};
          obj2["SAP_ID"] = d?.SAP_ID;
          obj2["Zone"] = d?.userDetails?.zone;
          obj2["Region"] = d?.userDetails?.region;
          obj2["Territory"] = d?.userDetails?.territory;
          obj2["Category"] = d?.visitType;
          obj2["Dealer Code"] = "NA";
          obj2["Dealer Name"] = d?.dealerName;
          obj2["On Date"] = moment.utc(d?.startTime).format("YYYY-MM-DD");
          obj2["Start Time"] = moment.utc(d?.startTime).format("HH:mm");
          obj2["End Time"] = d?.endTime
            ? moment.utc(d?.endTime).format("HH:mm")
            : "NA";
          obj2["Time Spent (in mins)"] = timeSpent(
            moment(d?.startTime ? d?.startTime : ""),
            moment(d?.endTime ? d?.endTime : "")
          )
            .asMinutes()
            .toFixed(0);
          obj2[
            "Start Location"
          ] = `Lat: ${d?.startLat}, Long: ${d?.startLong} `;
          obj2["End Location"] = `Lat: ${d?.endLat}, Long: ${d?.endLong} `;
          (obj2["Visit Type"] =
            d?.unplanned === false ? "Planned" : "UnPlanned"),
            (obj2["Distance Flag"] =
              calculateDistance(secVisitCoordinates) === "NA"
                ? "NA"
                : calculateDistance(secVisitCoordinates) < 100
                ? "< 100 m"
                : ">100 m");
          (obj2["Completed"] = d?.completed === false ? "False" : "True"),
            (obj2["Remark"] = d?.remark);
          data.push(obj2);
          break;

        case "DEALER":
          let obj3 = {};
          let coordinates = {
            lat1: d?.startVisitLocation?.lat ? d?.startVisitLocation?.lat : 0,
            long1: d?.startVisitLocation?.long
              ? d?.startVisitLocation?.long
              : 0,
            lat2: d?.endVisitLocation?.lat ? d?.endVisitLocation?.lat : 0,
            long2: d?.endVisitLocation?.long ? d?.endVisitLocation?.long : 0,
          };

          obj3["SAP_ID"] = d?.SAP_ID;
          obj3["Zone"] = d?.userDetails?.zone;
          obj3["Region"] = d?.userDetails?.region;
          obj3["Area"] = d?.userDetails?.area;
          obj3["Territory"] = d?.userDetails?.territory;
          obj3["Category"] = d?.visitType;
          obj3["Dealer Code"] = d?.dealerCode;
          obj3["Dealer Name"] = d?.dealerName;
          obj3["On Date"] = moment.utc(d?.startTime).format("YYYY-MM-DD");
          obj3["Start Time"] = moment.utc(d?.startTime).format("HH:mm");
          obj3["End Time"] = d?.endTime
            ? moment.utc(d?.endTime).format("HH:mm")
            : "NA";
          obj3["Time Spent (in mins)"] = timeSpent(
            moment(d?.startTime ? d?.startTime : ""),
            moment(d?.endTime ? d?.endTime : "")
          )
            .asMinutes()
            .toFixed(0);
          obj3[
            "Start Location"
          ] = `Lat: ${d?.startVisitLocation?.lat}, Long: ${d?.startVisitLocation?.long},
          `;
          obj3[
            "End Location"
          ] = `Lat: ${d?.endVisitLocation?.lat}, Long: ${d?.endVisitLocation?.long},
        `;
          (obj3["Visit Type"] =
            d?.unplanned === false ? "Planned" : "UnPlanned"),
            (obj3["Distance Flag"] =
              calculateDistance(coordinates) === "NA"
                ? "NA"
                : calculateDistance(coordinates) < 100
                ? "< 100 m"
                : ">100 m");
          (obj3["Completed"] = d?.completed === false ? "False" : "True"),
            (obj3["Remark"] = d?.remark ? d?.remark : "NA");
          // ...tempOBj,
          d?.visitActions.map((item, idx) => {
            obj3[`${idx + 1}_Visit_Type`] = item.type;
            obj3[`${idx + 1}_Visit_Action_Taken`] = item.actionTaken;
            obj3[`${idx + 1}_Visit_Action_Completed`] = item.completed;
          });
          data.push(obj3);
          break;
        default:
          break;
      }
    }
    const fileName = `Visit-Data`;
    exportExcel(data, fileName);
    setDownloadReady(false);
    setLoadingVisits(false);
    setDisableButton(false);
  };

  const generateSpentTimeCSV = async () => {
    setLoadingTimeSpent(true);
    setDisableTimeButton(true);
    const response = await basicAuth()({
      url: `/jk-msfa/time-spent/app?startDate=${timeSpentStartDate}&endDate=${timeSpentEndDate}&userId=${SAP_ID}&role=${role}`,
      method: "GET",
    });
    setTimeSpentData(response);
    setLoadingTimeSpent(false);
    setDisableTimeButton(false);
    setDownloadCheckTime(true);
  };

  const downloadTimeSpentCSV = async () => {
    setLoadingTimeSpent(true);
    const fileName = "Time-Spent";
    exportExcel(
      timeSpentData.data.data.map((x) => ({
        "SAP ID": x?.SAP_ID,
        "Date ": x?.date,
        "Time Spent (mins)": (x?.total_seconds / 60).toFixed(0),
      })),
      fileName
    );
    setDownloadCheckTime(false);
    setLoadingTimeSpent(false);
  };

  const handleUniqueHits = async () => {
    const response = await basicAuth()({
      url: `/jk-msfa/unique-hits?startDate=${uniqueHitsStartDate}&endDate=${uniqueHitsEndDate}`,
      method: "GET",
    });

    const fileName = "Unique-Hits";
    exportExcel(
      response.data.data.map((x) => ({
        "SAP ID": x?.SAP_ID,
      })),
      fileName
    );
  };

  const generatePJP_CSV = async () => {
    setLoadingPJP(true);
    setDisablePJPButton(true);
    setIsPJPGenerated(false);
    await getAllPJPstats({
      start: pjpStartDate,
      end: pjpEndDate,
    })
      .then((data) => {
        setPjpData(data?.data);
        setIsPJPGenerated(true);
        setLoadingPJP(false);
        setDisablePJPButton(false);
      })
      .catch((err) => console.log("error", err));
  };

  const handlePJPstats = async () => {
    setLoadingPJP(true);
    const fileName = "PJP-Report";
    let csvdata = [];
    for await (let d of pjpData) {
      let obj = {};
      let totalVisitsDone = d?.VisitData !== null ? d?.VisitData.length : 0;

      let visitcount = d?.VisitData.reduce(
        (acc, obj) => {
          acc[obj.unplanned]++;
          return acc;
        },
        { true: 0, false: 0 }
      );

      let planned = d?.VisitData.filter((obj) => !obj.unplanned).map(
        (obj) => obj.dealer
      );

      let unplanned = d?.VisitData.filter((obj) => obj.unplanned).map(
        (obj) => obj.dealer
      );

      obj["SAP_ID"] = d?.SAP_ID;
      obj["Zone"] = d?.UserDetails?.zone ? d?.UserDetails?.zone : "-";
      obj["Region"] = d?.UserDetails?.region ? d?.UserDetails?.region : "-";
      obj["Area"] = d?.UserDetails?.area ? d?.UserDetails?.area : "-";
      obj["Territory"] = d?.UserDetails?.territory
        ? d?.UserDetails?.territory
        : "-";
      obj["Activity"] = d?.Activity;
      obj["Status"] = d?.Status;
      obj["Dealers Planned"] = d?.Dealers !== null ? d?.Dealers.join(", ") : "";
      obj["Plan Date"] = moment.utc(d?.PlanDate).format("YYYY-MM-DD");
      obj["Beat Name"] =
        d?.Beats !== null ? d?.Beats.map((obj) => obj.name).join(", ") : "";
      obj["Beat Route"] =
        d?.Beats !== null ? d?.Beats.map((obj) => obj.route).join(", ") : "";
      obj["Start Point"] =
        d?.Beats !== null
          ? d?.Beats.map((obj) => obj.startPoint.name).join(", ")
          : "";
      obj["End Point"] =
        d?.Beats !== null
          ? d?.Beats.map((obj) => obj.endPoint.name).join(", ")
          : "";
      obj["Actual Dealers Visited"] =
        d?.Dealers !== null ? planned.join(", ") : "";
      obj["Planned Visits"] = visitcount.false;
      obj["UnPlanned Visits"] = visitcount.true;
      obj["Total Visits Done"] = totalVisitsDone;
      obj["Remark"] = d?.Remark || "NA";
      csvdata.push(obj);
    }

    exportExcel(csvdata, fileName);
    setIsPJPGenerated(false);
    setLoadingPJP(false);
  };

  const generateLeadsCSV = async () => {
    setLoadingLeads(true);
    //call network API and get data then set lead data
    setLeadsData("");
    setDownloadCheckLeads(true);
    setLoadingLeads(false);
  };

  const handleLeadsReport = async () => {
    setLoadingLeads(true);
    const fileName = "Leads-Report";
    for await (let d of leadsData) {
      switch (d?.type) {
        case "PROSPECT":
          let obj = {};
          obj["SAP_ID"] = d?.userData?.SAP_ID;
          obj["Zone"] = d?.userData?.zone;
          obj["Region"] = d?.userData?.regionName;
          obj["Area"] = d?.userData?.areaName;
          obj["Territory"] = d?.userData?.territoryName;
          obj["Prospect Type"] = d?.type;
          obj["Firm Name"] = d?.basicDetails?.firmName || "";
          obj["Lead Type"] = d?.basicDetails?.leadType;
          obj["Date of Creation"] = moment
            .utc(d?.createdAt)
            .format("YYYY-MM-DD");
          obj["Phone"] = d?.basicDetails?.phoneNumber;
          obj["Address"] = `${d?.basicDetails?.address1 || ""} ${
            d?.basicDetails?.address2 || ""
          } ${d?.basicDetails?.districtName || ""} ${d?.state?.name || ""} ${
            d?.basicDetails?.pinCode || ""
          }`;
          obj["Location"] = `Lat : ${d?.basicDetails.lat || 0}, Long : ${
            d?.basicDetails.long || 0
          }`;
          data.push(obj);
          break;

        case "CUSTOMER":
          let obj1 = {};
          obj1["SAP_ID"] = d?.userData?.SAP_ID;
          obj1["Zone"] = d?.userData?.zone;
          obj1["Region"] = d?.userData?.regionName;
          obj1["Area"] = d?.userData?.areaName;
          obj1["Territory"] = d?.userData?.territoryName;
          obj1["Prospect Type"] = d?.type;
          obj1["Firm Name"] = d?.businessDetails?.firmName || "";
          obj1["Lead Type"] = "NA";
          obj1["Date of Creation"] = moment
            .utc(d?.createdAt)
            .format("YYYY-MM-DD");
          obj1["Phone"] = d?.basicDetails[0]?.phoneNumber;
          obj1["Address"] = `${d?.businessDetails?.address?.address1 || ""} ${
            d?.businessDetails?.address?.address2 || ""
          } ${d?.businessDetails?.address?.address3} ${
            d?.businessDetails?.address?.district
          } ${d?.businessDetails?.address?.state} ${
            d?.businessDetails.paddress?.pincode || ""
          }`;
          obj1["Location"] = `Lat : ${d?.businessDetails.lat || 0}, Long : ${
            d?.businessDetails.long || 0
          }`;
          data.push(obj1);
          break;

        case "INFLUENCER":
          let obj2 = {};
          obj2["SAP_ID"] = d?.userData?.SAP_ID;
          obj2["Zone"] = d?.userData?.zone;
          obj2["Region"] = d?.userData?.regionName;
          obj2["Area"] = d?.userData?.areaName;
          obj2["Territory"] = d?.userData?.territoryName;
          obj2["Prospect Type"] = d?.type
            ? d?.type
            : d?.prospectType.toUpperCase();
          obj2["Firm Name"] = d?.name || "";
          obj2["Lead Type"] = "NA";
          obj2["Date of Creation"] = moment
            .utc(d?.createdAt)
            .format("YYYY-MM-DD");
          obj2["Phone"] = d?.phoneNumber;
          obj2["Address"] = `${d?.address?.streetNumber || ""} ${
            d?.address?.address1 || ""
          } ${d?.address?.address2 || ""} ${d?.address?.district || ""} ${
            d?.state?.name
          } ${d.paddress?.pincode || ""}`;
          obj2["Location"] = `Lat : ${d?.lat || 0}, Long : ${d?.long || 0}`;
          data.push(obj2);
          break;

        default:
          break;
      }
    }
    exportExcel(data, fileName);
    setDownloadCheckLeads(false);
    setLoadingLeads(false);
  };

  const generateCallOptCSV = async () => {
    setLoadingCallOpt(true);
    setDisableCallOptButton(true);
    await getCallOptData({
      start: callOptStartDate,
      end: callOptEndDate,
      user: SAP_ID,
    })
      .then((data) => {
        setCallOptData(data?.arrayOfUsers);
        setLoadingCallOpt(false);
        setIsCallOptGenerated(true);
        setDisableCallOptButton(false);
      })
      .catch((err) => console.log("error", err));
  };

  const generateROCallOptCSV = async () => {
    setLoadingROCallOpt(true);
    setDisableROCallOptButton(true);
    await getROCallOptData({
      start: callOptStartDate,
      end: callOptEndDate,
      user: SAP_ID,
    })
      .then((data) => {
        setROCallOptData(data?.arrayOfUsers);
        setLoadingROCallOpt(false);
        setIsROCallOptGenerated(true);
        setDisableROCallOptButton(false);
      })
      .catch((err) => console.log("error", err));
  };

  const generateAttendanceData = async () => {
    setLoadingAttendance(true);
    setDisableAttendanceButton(true);
    await getAttendanceData({
      start: attendanceStartDate,
      end: attendanceEndDate,
    })
      .then((data) => {
        setAttendanceData(data?.data);
        setLoadingAttendance(false);
        setIsAttedanceGenerated(true);
        setDisableAttendanceButton(false);
      })
      .catch((err) => console.log("error", err));
  };

  const downloadCallOptimizedReport = async (e) => {
    e.preventDefault();
    setLoadingCallOpt(true);
    const fileName = "COR_Daily.xlsx";
    const startDate = new Date(callOptStartDate);
    const endDate = new Date(callOptEndDate);
    const updatedRecord = callOptData.map((userRecord) => {
      const updatedUserRecord = { ...userRecord };
      updatedUserRecord.dayWiseRecord = {};
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split("T")[0];
        const value = userRecord.dayWiseRecord[formattedDate] || 0;
        updatedUserRecord.dayWiseRecord[formattedDate] = value;
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return updatedUserRecord;
    });

    let newArr = updatedRecord.map((obj) => {
      let newObj = {
        SAP_ID: obj.SAP_ID || "error",
        "Territory Name": obj?.territoryName || "Not Available",
        "Gross Working Days (excl Sundays | Sat Half Days)":
          ((obj?.totalDays || 0) - (obj?.sundayCount || 0)) || 0,
        "No. of Holidays & Leaves":
          (obj?.holidayCount || 0) + (obj?.leavesApproved || 0),
        "No. of Days in Office (Office + Meeting + Training)":
          obj?.offFieldDays || 0,
        "Total Field Days":
          obj?.totalDays -
          ((obj?.holidayCount ? obj?.holidayCount : 0) +
            (obj?.leavesApproved ? obj?.leavesApproved : 0) +
            (obj?.sundayCount ? obj?.sundayCount : 0) +
            (obj?.offFieldDays ? obj?.offFieldDays : 0)),
        "Total Call": obj?.totalCount || 0,
        "Avg calls/Day":
          (
            obj?.totalCount /
            (obj?.totalDays -
              ((obj?.holidayCount ? obj?.holidayCount : 0) +
                (obj?.leavesApproved ? obj?.leavesApproved : 0) +
                (obj?.sundayCount ? obj?.sundayCount : 0) +
                (obj?.offFieldDays ? obj?.offFieldDays : 0)))
          ).toFixed(2) || 0,
        "No of days - Day start b/w 9.30-10":
          obj?.startTimeBefore10AMCount || 0,
        "Avg time spent/call (in mins)": obj?.avgTimeSpend.slice(0, -3) || 0,
        "Planned Vs Unplanned -%":
          `${obj?.unplannedFalseCount}/${obj?.unplannedTrueCount}` || 0,
        "% calls to active Dealers":
          (obj?.ACTIVE_DEALER || 0) +
            "/" +
            ((obj?.ACTIVE_DEALER / obj?.totalCount) * 100).toFixed(2) +
            "%" || 0,
        "% calls to Inactive Dealers":
          (obj?.INACTIVE_DEALER || 0) +
            "/" +
            ((obj?.INACTIVE_DEALER / obj.totalCount) * 100).toFixed(2) +
            "%" || 0,
        "% calls to Prospects Dealers":
          (obj?.visitTypeCounts?.PROSPECTS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.PROSPECTS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
        "% calls to Influencer Dealers":
          (obj?.visitTypeCounts?.INFLUENCERS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.INFLUENCERS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
        "% calls to Customers":
          (obj?.visitTypeCounts?.CUSTOMERS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.CUSTOMERS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
      };
      // Iterate over the properties of the add object and add them dynamically to newObj
      for (let key in obj.dayWiseRecord) {
        newObj[key] = obj.dayWiseRecord[key];
      }
      return newObj;
    });

    let emparr = [];
    let text = [
      {
        value:
          "Note: This report excludes data on National & Regional Holidays, Meetings, Leaves, Trainings, and Office Plans.",
        SAP_ID: "Exclusions",
      },
    ];
    let excelData = await transmissionData(newArr, startDate, endDate);
    excelData.push(emparr);
    excelData.push(text);
    const downloadXlsxFile = () => {
      writeXlsxFile(excelData, {
        fileName: fileName,
      });
    };
    downloadXlsxFile();
    setLoadingCallOpt(false);
    setIsCallOptGenerated(false);
    setDisableCallOptButton(false);
  };

  const downloadROCallOptimizedReport = async (e) => {
    e.preventDefault();
    setLoadingROCallOpt(true);
    const fileName = "COR_Daily.xlsx";
    const startDate = new Date(callOptStartDate);
    const endDate = new Date(callOptEndDate);
    const updatedRecord = ROCallOptData.map((userRecord) => {
      const updatedUserRecord = { ...userRecord };
      updatedUserRecord.dayWiseRecord = {};
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split("T")[0];
        const value = userRecord.dayWiseRecord[formattedDate] || 0;
        updatedUserRecord.dayWiseRecord[formattedDate] = value;
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return updatedUserRecord;
    });

    let newArr = updatedRecord.map((obj) => {
      let newObj = {
        SAP_ID: obj.SAP_ID || "error",
        "Territory Name": obj?.territoryName || "Not Available",
        "Gross Working Days (excl Sundays | Sat Half Days)":
          ((obj?.totalDays || 0) - (obj?.sundayCount || 0)) || 0,
        "No. of Holidays & Leaves":
          (obj?.holidayCount || 0) + (obj?.leavesApproved || 0),
        "No. of Days in Office (Office + Meeting + Training)":
          obj?.offFieldDays || 0,
        "Total Field Days":
          obj?.totalDays -
          ((obj?.holidayCount ? obj?.holidayCount : 0) +
            (obj?.leavesApproved ? obj?.leavesApproved : 0) +
            (obj?.sundayCount ? obj?.sundayCount : 0) +
            (obj?.offFieldDays ? obj?.offFieldDays : 0)),
        "Total Call": obj?.totalCount || 0,
        "Avg calls/Day":
          (
            obj?.totalCount /
            (obj?.totalDays -
              ((obj?.holidayCount ? obj?.holidayCount : 0) +
                (obj?.leavesApproved ? obj?.leavesApproved : 0) +
                (obj?.sundayCount ? obj?.sundayCount : 0) +
                (obj?.offFieldDays ? obj?.offFieldDays : 0)))
          ).toFixed(2) || 0,
        "No of days - Day start b/w 9.30-10":
          obj?.startTimeBefore10AMCount || 0,
        "Avg time spent/call (in mins)": obj?.avgTimeSpend.slice(0, -3) || 0,
        "Planned Vs Unplanned -%":
          `${obj?.unplannedFalseCount}/${obj?.unplannedTrueCount}` || 0,
        "% calls to active Dealers":
          (obj?.ACTIVE_DEALER || 0) +
            "/" +
            ((obj?.ACTIVE_DEALER / obj?.totalCount) * 100).toFixed(2) +
            "%" || 0,
        "% calls to Inactive Dealers":
          (obj?.INACTIVE_DEALER || 0) +
            "/" +
            ((obj?.INACTIVE_DEALER / obj.totalCount) * 100).toFixed(2) +
            "%" || 0,
        "% calls to Prospects Dealers":
          (obj?.visitTypeCounts?.PROSPECTS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.PROSPECTS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
        "% calls to Influencer Dealers":
          (obj?.visitTypeCounts?.INFLUENCERS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.INFLUENCERS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
        "% calls to Customers":
          (obj?.visitTypeCounts?.CUSTOMERS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.CUSTOMERS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
      };
      // Iterate over the properties of the add object and add them dynamically to newObj
      for (let key in obj.dayWiseRecord) {
        newObj[key] = obj.dayWiseRecord[key];
      }
      return newObj;
    });

    let emparr = [];
    let text = [
      {
        value:
          "Note: This report excludes data on National & Regional Holidays, Meetings, Leaves, Trainings, and Office Plans.",
        SAP_ID: "Exclusions",
      },
    ];
    let excelData = await transmissionData(newArr, startDate, endDate);
    excelData.push(emparr);
    excelData.push(text);
    const downloadXlsxFile = () => {
      writeXlsxFile(excelData, {
        fileName: fileName,
      });
    };
    downloadXlsxFile();
    setLoadingROCallOpt(false);
    setIsROCallOptGenerated(false);
    setDisableROCallOptButton(false);
  };

  const downloadAttendanceReport = async (e) => {
    e.preventDefault();
    setLoadingAttendance(true);
    const fileName = "Attendance Report.xlsx";
    const startDate = new Date(attendanceStartDate);
    const endDate = new Date(attendanceEndDate);
    const updatedRecord = attendanceData?.map((userRecord) => {
      const updatedUserRecord = { ...userRecord };
      updatedUserRecord.dayWiseRecord = {};
      const currentDate = new Date(startDate);
      console.log("current", currentDate);
      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split("T")[0];
        let newobj = userRecord?.data?.find(
          (entry) => entry?.onDate === `${formattedDate}T00:00:00.000Z`
        );
        console.log("current", newobj);
        updatedUserRecord.dayWiseRecord[formattedDate] = newobj
          ? {
              checkIn: newobj?.checkIn
                ? moment
                    .utc(newobj?.checkIn?.time)
                    .add(330, "minutes")
                    .format("hh:mm A")
                : "-",
              checkOut: newobj?.checkOut
                ? moment
                    .utc(newobj?.checkOut?.time)
                    .add(330, "minutes")
                    .format("hh:mm A")
                : "-",
              status: newobj?.status,
            }
          : { checkIn: "-", checkOut: "-", status: "-" };
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return updatedUserRecord;
    });

    let newArr = updatedRecord.map((obj) => {
      let newObj = {
        SAP_ID: obj?.data[0]?.SAP_ID || "error",
        Territory: obj?.data[0]?.territory || "NA",
        Area: obj?.data[0]?.area || "NA",
        Region: obj?.data[0]?.region || "NA",
        Zone: obj?.data[0]?.zone || "NA",
      };
      for (let key in obj.dayWiseRecord) {
        newObj[key] = obj.dayWiseRecord[key];
      }
      return newObj;
    });
    console.log("arru", newArr);

    let excelData = await attendanceDataExcel(newArr, startDate, endDate);
    const downloadXlsxFile = () => {
      writeXlsxFile(excelData, {
        fileName: fileName,
      });
    };
    downloadXlsxFile();
    setLoadingAttendance(false);
    setIsAttedanceGenerated(false);
    setDisableAttendanceButton(false);
  };

  const generateCpmCSV = async (filter) => {
    setLoadingCpm(true);
    setDisableCpmButton(true);
    await getCpmDataMonthly({
      start: cpmStartDate,
      end: cpmEndDate,
      user: SAP_ID,
      ...filter,
    })
      .then((data) => {
        // console.log("🚀 ~ file: index.js:625 ~ data:", data);
        setCpmData(data?.cmpData);
        setLoadingCpm(false);
        setIsCpmGenerated(true);
        setDisableCpmButton(false);
      })
      .catch((err) => {
        setLoadingCpm(false);
        setDisableCpmButton(true);
        return toast.error(err.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      });
  };
  const downloadCpmCSV = async () => {
    let from = cpmStartDate.split("T")[0];
    let to = cpmEndDate.split("T")[0];
    const cpmFileName = `COR-from_${from}_to_${to}_`;
    let cpmArray = await cpmData?.map((obj) => {
      console.log("newobj", obj);
      let newObj = {
        ZONE: obj.zone,
        Region: obj.regionCode,
        "Region Name": obj.regionName,
        Area: obj.areaCode,
        "Area Name": obj.areaName,
        Territory: obj.territoryCode,
        "Territory Name": obj.territoryName,
        Month: obj.month || "error",
        "Total Call": obj?.totalCall || 0,
        "Avg calls/Day":
          (
            obj?.totalCall /
            ((obj?.totalDays ? obj?.totalDays : 25) -
              (obj?.holidayCount ? obj?.holidayCount : 0))
          ).toFixed(2) || 0,
        "No of days - Day start b/w 9.30-10": obj?.earlyCall || 0,
        "Avg time spent/call (in mins)":
          Math.floor(
            obj?.totalTimeInMilSec / (60 * 1000 * obj?.totalCall)
          ).toFixed(2) || 0,
        "Planned Vs Unplanned call": `${obj?.planned}/${obj?.unplanned}` || 0,
        "Total Calls / % calls to active Dealers":
          obj?.activeDealerCall +
            "/" +
            ((obj?.activeDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Inactive Dealers":
          obj?.inactiveDealerCall +
            "/" +
            ((obj?.inactiveDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Prospects Dealers":
          obj?.prospectDealerCall +
            "/" +
            ((obj?.prospectDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Influencer Dealers":
          obj?.influencerDealerCall +
            "/" +
            ((obj?.influencerDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Customers":
          obj?.customerCall +
            "/" +
            ((obj?.customerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
      };
      return newObj;
    });
    if (cpmArray && cpmArray.length) {
      let emparr = {};
      cpmArray.push(emparr);
      let text = {
        ZONE: "Note: This report excludes data on National & Regional Holidays, Meetings, Leaves, Trainings, and Office Plans.",
      };
      cpmArray.push(text);
      console.log("comap", cpmArray);
      exportExcel(cpmArray, cpmFileName);
      setIsCpmGenerated(false);
      setDisableCpmButton(false);
      setLoadingCpm(false);
    } else {
      return toast.error("No Data found to download.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };


  const generateROCpmCSV = async (filter) => {
    setLoadingROCpm(true);
    setDisableROCpmButton(true);
    await getROCpmDataMonthly({
      start: ROCpmStartDate,
      end: ROCpmEndDate,
      user: SAP_ID,
      ...filter,
    })
      .then((data) => {
        // console.log("🚀 ~ file: index.js:625 ~ data:", data);
        setROCpmData(data?.cmpData);
        setLoadingROCpm(false);
        setIsROCpmGenerated(true);
        setDisableROCpmButton(false);
      })
      .catch((err) => {
        setLoadingROCpm(false);
        setDisableROCpmButton(true);
        return toast.error(err.message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      });
  };
  const downloadROCpmCSV = async () => {
    let from = ROCpmStartDate.split("T")[0];
    let to = ROCpmEndDate.split("T")[0];
    const cpmFileName = `COR-from_${from}_to_${to}_`;
    let cpmArray = await ROCpmData?.map((obj) => {
      console.log("newobj", obj);
      let newObj = {
        Zone: obj.zone || "error",
        Region: obj.regionCode,
        "Region Name": obj.regionName,
        Month: obj.month || "error",
        "Total Call": obj?.totalCall || 0,
        "Avg calls/Day":
          (
            obj?.totalCall /
            ((obj?.totalDays ? obj?.totalDays : 25) -
              (obj?.holidayCount ? obj?.holidayCount : 0))
          ).toFixed(2) || 0,
        "No of days - Day start b/w 9.30-10": obj?.earlyCall || 0,
        "Avg time spent/call (in mins)":
          Math.floor(
            obj?.totalTimeInMilSec / (60 * 1000 * obj?.totalCall)
          ).toFixed(2) || 0,
        "Planned Vs Unplanned call": `${obj?.planned}/${obj?.unplanned}` || 0,
        "Total Calls / % calls to active Dealers":
          obj?.activeDealerCall +
            "/" +
            ((obj?.activeDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Inactive Dealers":
          obj?.inactiveDealerCall +
            "/" +
            ((obj?.inactiveDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Prospects Dealers":
          obj?.prospectDealerCall +
            "/" +
            ((obj?.prospectDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Influencer Dealers":
          obj?.influencerDealerCall +
            "/" +
            ((obj?.influencerDealerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
        "Total Calls / % calls to Customers":
          obj?.customerCall +
            "/" +
            ((obj?.customerCall / obj?.totalCall) * 100).toFixed(2) +
            "%" || 0,
      };
      return newObj;
    });
    if (cpmArray && cpmArray.length) {
      let emparr = {};
      cpmArray.push(emparr);
    
      console.log("comap", cpmArray);
      exportExcel(cpmArray, cpmFileName);
      setIsROCpmGenerated(false);
      setDisableROCpmButton(false);
      setLoadingROCpm(false);
    } else {
      return toast.error("No Data found to download.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };


  const getRegionsCode = async () => {
    try {
      if (!(cpmStartDate && cpmEndDate)) {
        return toast.error("Error: Please select date range first.", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      }
      setFilterLoading(true);
      setDisableSubmit(true);
      const data = await getRegionsByZone();
      setRegionsCode(data?.RegionData);
      setAppliedFilter(true);
      setFilterLoading(false);
    } catch (err) {
      toast.error(err.message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };

  const handleCloseFilter = () => {
    setAppliedFilter(false);
  };
  const onSubmitFilter = (filter) => {
    generateCpmCSV(filter);
    setAppliedFilter(false);
    setIsCpmGenerated(true);
    // setLoadingCpm(true);
  };
  const renderFilter = () => {
    return filterLoading ? (
      <CircularProgress size="1.53rem" />
    ) : (
      <FilterAltIcon />
    );
  };

  const generateCallOptimizedReportRO = async () => {
    setLoadingOptReportRO(true);
    setDisableOptReportROButton(true);
    await getCallOptDataDailyRO({
      start: OptReportROStartDate,
      end: OptReportROEndDate,
      user: SAP_ID,
    })
      .then((data) => {
        setOptReportROData(data?.arrayOfUsers);
        setLoadingOptReportRO(false);
        setIsOptReportROGenerated(true);
        setDisableOptReportROButton(false);
      })
      .catch((err) => console.log("error", err));
  };
  
  const downloadCallOptimizedReportRO = async (e) => {
    e.preventDefault();
    setLoadingOptReportRO(true);
    const fileName = "COR_Daily.xlsx";
    const startDate = new Date(OptReportROStartDate);
    const endDate = new Date(OptReportROEndDate);
    const updatedRecord = OptReportROData.map((userRecord) => {
      const updatedUserRecord = { ...userRecord };
      updatedUserRecord.dayWiseRecord = {};
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split("T")[0];
        const value = userRecord.dayWiseRecord[formattedDate] || 0;
        updatedUserRecord.dayWiseRecord[formattedDate] = value;
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return updatedUserRecord;
    });
console.log(updatedRecord);
    let newArr = updatedRecord.map((obj) => {
      let newObj = {
        SAP_ID: obj.SAP_ID || "error",
        "Region Name": obj?.regionName || "Not Available",
        "Gross Working Days (excl Sundays | Sat Half Days)":
          ((obj?.totalDays || 0) - (obj?.sundayCount || 0)) || 0,
        "No. of Holidays & Leaves":
          (obj?.holidayCount || 0) + (obj?.leavesApproved || 0),
        "No. of Days in Office (Office + Meeting + Training)":
          obj?.offFieldDays || 0,
        "Total Field Days":
          obj?.totalDays -
          ((obj?.holidayCount ? obj?.holidayCount : 0) +
            (obj?.leavesApproved ? obj?.leavesApproved : 0) +
            (obj?.sundayCount ? obj?.sundayCount : 0) +
            (obj?.offFieldDays ? obj?.offFieldDays : 0)),
        "Total Call": obj?.totalCount || 0,
        "Avg calls/Day":
          (
            obj?.totalCount /
            (obj?.totalDays -
              ((obj?.holidayCount ? obj?.holidayCount : 0) +
                (obj?.leavesApproved ? obj?.leavesApproved : 0) +
                (obj?.sundayCount ? obj?.sundayCount : 0) +
                (obj?.offFieldDays ? obj?.offFieldDays : 0)))
          ).toFixed(2) || 0,
        "No of days - Day start b/w 9.30-10":
          obj?.startTimeBefore10AMCount || 0,
        "Avg time spent/call (in mins)": obj?.avgTimeSpend.slice(0, -3) || 0,
        "Planned Vs Unplanned -%":
          `${obj?.unplannedFalseCount}/${obj?.unplannedTrueCount}` || 0,
        "% calls to active Dealers":
          (obj?.ACTIVE_DEALER || 0) +
            "/" +
            ((obj?.ACTIVE_DEALER / obj?.totalCount) * 100).toFixed(2) +
            "%" || 0,
        "% calls to Inactive Dealers":
          (obj?.INACTIVE_DEALER || 0) +
            "/" +
            ((obj?.INACTIVE_DEALER / obj.totalCount) * 100).toFixed(2) +
            "%" || 0,
        "% calls to Prospects Dealers":
          (obj?.visitTypeCounts?.PROSPECTS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.PROSPECTS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
        "% calls to Influencer Dealers":
          (obj?.visitTypeCounts?.INFLUENCERS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.INFLUENCERS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
        "% calls to Customers":
          (obj?.visitTypeCounts?.CUSTOMERS || 0) +
            "/" +
            (
              (obj?.visitTypeCounts?.CUSTOMERS / obj.totalCount) * 100 || 0
            ).toFixed(2) +
            "%" || 0,
      };
      // Iterate over the properties of the add object and add them dynamically to newObj
      for (let key in obj.dayWiseRecord) {
        newObj[key] = obj.dayWiseRecord[key];
      }
      return newObj;
    });

    let emparr = [];
    let text = [
      {
        value:
          "Note: This report excludes data on National & Regional Holidays, Meetings, Leaves, Trainings, and Office Plans.",
        SAP_ID: "Exclusions",
      },
    ];
    let excelData = await transmissionDataRO(newArr, startDate, endDate);
    excelData.push(emparr);
    excelData.push(text);
    const downloadXlsxFile = () => {
      writeXlsxFile(excelData, {
        fileName: fileName,
      });
    };
    downloadXlsxFile();
    setLoadingOptReportRO(false);
    setIsOptReportROGenerated(false);
    setDisableOptReportROButton(false);
  };

  // const handleExport = async () => {
  //   // Create a new workbook and a worksheet
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("My Sheet");

  //   // Row 1 - Merged Cells for main headers
  //   worksheet.mergeCells("A1:A2"); // Merges the rows for 'Name'
  //   worksheet.mergeCells("B1:D1"); // Merges the cells for 'Date'
  //   worksheet.getCell("B1").value = "Date";
  //   worksheet.mergeCells("E1:E2"); // Merges the rows for 'Status'
  //   worksheet.getCell("E1").value = "Status";
  //   worksheet.mergeCells("F1:G1"); // Merges the cells for 'Range'
  //   worksheet.getCell("F1").value = "Range";

  //   // Row 2 - Sub headers
  //   worksheet.getCell("A2").value = "Name";
  //   worksheet.getCell("B2").value = "Task 1";
  //   worksheet.getCell("C2").value = "Task 2";
  //   worksheet.getCell("D2").value = "Task 3";
  //   worksheet.getCell("F2").value = "Start";
  //   worksheet.getCell("G2").value = "End";

  //   const dataRows = [
  //     ["Shubham", "test1", "test2", "test3", "DONE", 5, 10],
  //     // Add more arrays for each additional row of data
  //     ["Person2", "test4", "test5", "test6", "IN PROGRESS", 15, 20],
  //     // ... and so on for each row
  //   ];

  //   // Adding Data Rows
  //   dataRows.forEach((rowValues) => {
  //     worksheet.addRow(rowValues);
  //   });

  //   worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
  //     // Skip the header rows
  //     if (rowNumber > 2) {
  //       const startCell = row.getCell(6); // Assuming 'Start' is in column F (6th column)
  //       const endCell = row.getCell(7); // Assuming 'End' is in column G (7th column)

  //       // Apply fill to 'Start' cell based on its value
  //       if (startCell.value >= 10) {
  //         startCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: "FFFF0000" }, // Red fill for 'Start' greater than 10
  //         };
  //       } else if (startCell.value >= 5) {
  //         startCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: "FF00FF00" }, // Green fill for 'Start' greater than 5
  //         };
  //       }

  //       // Apply fill to 'End' cell based on its value
  //       if (endCell.value > 10) {
  //         endCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: "FF0000FF" }, // Blue fill for 'End' greater than 10
  //         };
  //       }
  //       // You can add more conditions here for different colors if needed
  //     }
  //   });

  //   // Ensure the workbook views are setup properly (helpful for debugging)
  //   workbook.views = [
  //     {
  //       x: 0,
  //       y: 0,
  //       width: 10000,
  //       height: 20000,
  //       firstSheet: 0,
  //       activeTab: 0,
  //       visibility: "visible",
  //     },
  //   ];

  //   // Write to a buffer
  //   const buffer = await workbook.xlsx.writeBuffer();

  //   // Use FileSaver to save the file
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(blob, "example.xlsx");
  // };

  // const handleExport = () => {
  //   // Create a new workbook and a sheet
  //   const wb = XLSX.utils.book_new();
  //   const ws_data = [
  //     ["Name", "Date", null, null, "Status", "Range"],
  //     [null, "Task 1", "Task 2", "Task 3", null, "Start", "End"],
  //     [
  //       data.name,
  //       data.task1,
  //       data.task2,
  //       data.task3,
  //       data.status,
  //       data.startRange,
  //       data.endRange,
  //     ],
  //   ];

  //   const ws = XLSX.utils.aoa_to_sheet(ws_data);

  //   // Define merged cells
  //   const merge = [
  //     // Merge the "Date" cells from B1 to D1
  //     { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
  //     // Merge the "Range" cells from E1 to F1
  //     { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
  //     // Merge the "Status" cells from E1 to E2
  //     { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } },
  //   ];

  //   // Apply the merges to the worksheet
  //   if (!ws["!merges"]) ws["!merges"] = [];
  //   merge.forEach((m) => ws["!merges"].push(m));

  //   // Append the sheet to the workbook
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   // Write the workbook and initiate a download
  //   XLSX.writeFile(wb, "exported_data.xlsx");
  // };

  // const handleExport = async () => {
  //   // Create a new workbook and a worksheet
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("My Sheet");

  //   // Row 1 - Merged Cells for main headers
  //   worksheet.mergeCells("A1:A2"); // Merges the rows for 'Name'
  //   worksheet.mergeCells("B1:D1"); // Merges the cells for 'Date'
  //   worksheet.getCell("B1").value = "Date";
  //   worksheet.mergeCells("E1:E2"); // Merges the rows for 'Status'
  //   worksheet.getCell("E1").value = "Status";
  //   worksheet.mergeCells("F1:G1"); // Merges the cells for 'Range'
  //   worksheet.getCell("F1").value = "Range";

  //   // Row 2 - Sub headers
  //   worksheet.getCell("A2").value = "Name";
  //   worksheet.getCell("B2").value = "Task 1";
  //   worksheet.getCell("C2").value = "Task 2";
  //   worksheet.getCell("D2").value = "Task 3";
  //   worksheet.getCell("F2").value = "Start";
  //   worksheet.getCell("G2").value = "End";

  //   const dataRows = [
  //     ["Shubham", "test1", "test2", "test3", "DONE", 5, 10],
  //     // Add more arrays for each additional row of data
  //     ["Person2", "test4", "test5", "test6", "IN PROGRESS", 15, 20],
  //     // ... and so on for each row
  //   ];

  //   // Adding Data Rows
  //   dataRows.forEach((rowValues) => {
  //     worksheet.addRow(rowValues);
  //   });

  //   worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
  //     // Skip the header rows
  //     if (rowNumber > 2) {
  //       const startCell = row.getCell(6); // Assuming 'Start' is in column F (6th column)
  //       const endCell = row.getCell(7); // Assuming 'End' is in column G (7th column)

  //       // Apply fill to 'Start' cell based on its value
  //       if (startCell.value >= 10) {
  //         startCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: "FFFF0000" }, // Red fill for 'Start' greater than 10
  //         };
  //       } else if (startCell.value >= 5) {
  //         startCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: "FF00FF00" }, // Green fill for 'Start' greater than 5
  //         };
  //       }

  //       // Apply fill to 'End' cell based on its value
  //       if (endCell.value > 10) {
  //         endCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: "FF0000FF" }, // Blue fill for 'End' greater than 10
  //         };
  //       }
  //       // You can add more conditions here for different colors if needed
  //     }
  //   });

  //   // Ensure the workbook views are setup properly (helpful for debugging)
  //   workbook.views = [
  //     {
  //       x: 0,
  //       y: 0,
  //       width: 10000,
  //       height: 20000,
  //       firstSheet: 0,
  //       activeTab: 0,
  //       visibility: "visible",
  //     },
  //   ];

  //   // Write to a buffer
  //   const buffer = await workbook.xlsx.writeBuffer();

  //   // Use FileSaver to save the file
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(blob, "example.xlsx");
  // };

  // const handleExport = () => {
  //   // Create a new workbook and a sheet
  //   const wb = XLSX.utils.book_new();
  //   const ws_data = [
  //     ["Name", "Date", null, null, "Status", "Range"],
  //     [null, "Task 1", "Task 2", "Task 3", null, "Start", "End"],
  //     [
  //       data.name,
  //       data.task1,
  //       data.task2,
  //       data.task3,
  //       data.status,
  //       data.startRange,
  //       data.endRange,
  //     ],
  //   ];

  //   const ws = XLSX.utils.aoa_to_sheet(ws_data);

  //   // Define merged cells
  //   const merge = [
  //     // Merge the "Date" cells from B1 to D1
  //     { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
  //     // Merge the "Range" cells from E1 to F1
  //     { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
  //     // Merge the "Status" cells from E1 to E2
  //     { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } },
  //   ];

  //   // Apply the merges to the worksheet
  //   if (!ws["!merges"]) ws["!merges"] = [];
  //   merge.forEach((m) => ws["!merges"].push(m));

  //   // Append the sheet to the workbook
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   // Write the workbook and initiate a download
  //   XLSX.writeFile(wb, "exported_data.xlsx");
  // };



//   const generateSOSummary = async () => {
//     const token=localStorage.getItem("token")

// const response=await axios.get("http://localhost:8000/api/v1/report/SOSummaryReport",{
//   headers: {
//       'Content-type': 'application/json',
//       'Authorization': `Bearer ${token}`
//   }
// })

// console.log(response,"response")
// const SOSummaryData=response?.data?.summaryData;

//     const rows = [['SAP_ID', 'ProspectType', 'Name', 'Number']];
  
//     SOSummaryData.forEach(user => {
//       user.prospectData?.forEach(p => {
//         rows.push([
//           user.SAP_ID,
//           p.type,
//           p.businessinfodealerprospectData?.dealershipName || '',
//           p.businessinfodealerprospectData?.phoneNumber || ''
//         ]);
//       });
  
//       user.influencerData?.forEach(i => {
//         rows.push([
//           user.SAP_ID,
//           i.type,
//           i.name || '',
//           i.phoneNumber || ''
//         ]);
//       });
  
//       user.customerData?.forEach(c => {
//         rows.push([
//           user.SAP_ID,
//           c.type,
//           c.detailscustomer?.name || '',
//           c.detailscustomer?.phoneNumber || ''
//         ]);
//       });
//     });
  
//     await writeXlsxFile(rows, { name: 'summary.xlsx' });
//   };
 
useEffect(() => {
  if (SOSummaryStartDate && SOSummaryEndDate) {
    const start = new Date(SOSummaryStartDate);
    const end = new Date(SOSummaryEndDate);
    const differenceInDays = Math.floor(
      (end - start) / (1000 * 60 * 60 * 24)
    );
    if (differenceInDays < 1) {
      return toast.error(
        "End Date can not be smaller than Start Date",
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
    return setdisableSOSummaryButton(false);
  }
}, [SOSummaryStartDate, SOSummaryEndDate]);

const generateSOSummary = async () => {
  setLoadingSOSummary(true);
  setdisableSOSummaryButton(true)
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${process.env.REACT_APP_REQUEST_ENDPOINT}/api/v1/report/SOSummaryReport?startDate=${SOSummaryStartDate}&endDate=${SOSummaryEndDate}`,
    {
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    }
  );

  setSOSummaryData(response?.data?.summaryData);
  setSOSummaryGenerated(true)
  setLoadingSOSummary(false);
  setdisableSOSummaryButton(false)
 
};
  const downloadSOSummary = async (e) => {
    setdisableSOSummaryButton(true)
    setLoadingSOSummary(true);
    e.preventDefault();
    const exportData = [];

    SOSummaryData.forEach(user => {
      // Prospect Data
      user.prospectData?.forEach(p => {
        exportData.push({
          SAP_ID: user.SAP_ID,
          Territory:user.territoryName,
          Region:user.regionName,
          Zone:user.zone,
          ProspectType: p.type,
          Name: p.businessinfodealerprospectData?.dealershipName || '',
          Number: p.businessinfodealerprospectData?.phoneNumber || '',
          CreatedAt:p.createdAt
        });
      });
  
      // Influencer Data
      user.influencerData?.forEach(i => {
        exportData.push({
          SAP_ID: user.SAP_ID,
          Territory:user.territoryName,
          Region:user.regionName,
          Zone:user.zone,
          ProspectType: i.type,
          Name: i.name || '',
          Number: i.phoneNumber || '',
          CreatedAt:i.createdAt
  
        });
      });
  
      // Customer Direct Data
      user.customerData?.forEach(c => {
        exportData.push({
          SAP_ID: user.SAP_ID,
          Territory:user.territoryName,
          Region:user.regionName,
          Zone:user.zone,
          ProspectType: c.type,
          Name: c.detailscustomer?.name || '',
          Number: c.detailscustomer?.phoneNumber || '',
          CreatedAt:c.createdAt
  
        });
      });
  
         // Customer Indirect Data
         user.fleetData?.forEach(j => {
          exportData.push({
            SAP_ID: user.SAP_ID,
            Territory:user.territoryName,
            Region:user.regionName,
            Zone:user.zone,
            ProspectType: j.prospectType,
            Name: j.businessDetails?.companyName || '',
            Number: j.businessDetails?.transportContactNumber || '',
            CreatedAt:j.createdAt
          });
        });
    });
  
    // Trigger download
    exportExcel(exportData, "CIP REPORT");
    setdisableSOSummaryButton(false)
    setLoadingSOSummary(false);
    setSOSummaryGenerated(false)

  };
  return (
    <>
      <PageHeader
        title="Reports"
        subtitle="Generate and download operational reports"
      />

      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {filterLoading ? (
            ""
          ) : (
            <AdminFilter
              onOpen={appliedFilter}
              onClose={handleCloseFilter}
              data={regionsCode}
              disableButton={disableSubmit}
              onSubmit={onSubmitFilter}
            />
          )}
          <SectionCard title="Available Reports" disablePadding sx={{ mb: 2.5 }}>
            <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                    S No.
                  </TableCell>
                  <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                    Module
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Start Date
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    End Date
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell> 1 </TableCell>
                  <TableCell align="left">Visits Data</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={visitsStartDate}
                      onChange={(e) => setVisitsStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={visitsEndDate}
                      onChange={(e) => setVisitsEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {downloadReady ? (
                      <Button
                        //   type="submit"
                        variant="contained"
                        onClick={handleVisits}
                      >
                        {loadingVisits ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        onClick={generateVisitCSV}
                        disabled={disableButton}
                      >
                        {loadingVisits ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell> 2 </TableCell>
                  <TableCell align="left">Time Spent</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={timeSpentStartDate}
                      onChange={(e) => setTimeSpentStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={timeSpentEndDate}
                      onChange={(e) => setTimeSpentEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {downloadCheckTime ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadTimeSpentCSV}
                        // disabled={disableTimeButton}
                      >
                        {loadingTimeSpent ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        disabled={disableTimeButton}
                        onClick={generateSpentTimeCSV}
                      >
                        {loadingTimeSpent ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell> 3 </TableCell>
                  <TableCell align="left">PJP Planning Details</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={pjpStartDate}
                      onChange={(e) => setPjpStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={pjpEndDate}
                      onChange={(e) => setPjpEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {isPJPGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={handlePJPstats}
                        // disabled={disablePJPButton}
                      >
                        {loadingPJP ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generatePJP_CSV}
                        disabled={disablePJPButton}
                      >
                        {loadingPJP ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell> 4 </TableCell>
                  <TableCell align="left">Leads Report</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={leadsStartDate}
                      onChange={(e) => setLeadsStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={leadsEndDate}
                      onChange={(e) => setLeadsEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {downloadCheckLeads ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={handleLeadsReport}
                        // disabled={disableLeadsButton}
                      >
                        {loadingLeads ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generateLeadsCSV}
                        disabled={disableLeadsButton}
                      >
                        {loadingLeads ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell> 5 </TableCell>
                  <TableCell align="left">COR Report Daily</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={callOptStartDate}
                      onChange={(e) => setCallOptStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={callOptEndDate}
                      onChange={(e) => setCallOptEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {isCallOptGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadCallOptimizedReport}
                        // disabled={disableLeadsButton}
                      >
                        {loadingCallOpt ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generateCallOptCSV}
                        disabled={disableCallOptButton}
                      >
                        {loadingCallOpt ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
               
                <TableRow>
                  <TableCell> 6 </TableCell>
                  <TableCell align="left">COR Report Monthly</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={cpmStartDate}
                      onChange={(e) => setCpmStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={cpmEndDate}
                      onChange={(e) => setCpmEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {isCpmGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadCpmCSV}
                      >
                        {loadingCpm ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generateCpmCSV}
                        disabled={disableCpmButton}
                      >
                        {loadingCpm ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                    {/* {role === "ADMIN" ? (
                      <Button onClick={getRegionsCode}>{renderFilter()}</Button>
                    ) : (
                      ""
                    )} */}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell> 7 </TableCell>
                  <TableCell align="left">Attendance Report</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={attendanceStartDate}
                      onChange={(e) => setattendanceStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={attendanceEndDate}
                      onChange={(e) => setattendanceEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {isAttedanceGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadAttendanceReport}
                      >
                        {loadingAttendance ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generateAttendanceData}
                        disabled={disableAttendanceButton}
                      >
                        {loadingAttendance ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell> 8 </TableCell>
                  <TableCell align="left">Travel Plan Report</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={tpStartDate}
                      onChange={(e) => settpStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={tpEndDate}
                      onChange={(e) => settpEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {istpGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadtpCSV}
                      >
                        {loadingtp ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generatetpCSV}
                        disabled={disabletpButton}
                      >
                        {loadingtp ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                    {/* {role === "ADMIN" ? (
                      <Button onClick={getRegionsCode}>{renderFilter()}</Button>
                    ) : (
                      ""
                    )} */}
                  </TableCell>
                </TableRow>

                <TableRow>
<TableCell> 9 </TableCell>
<TableCell align="left">COR Report  for RO</TableCell>
<TableCell align="center">
  <DateInput
    value={ROCpmStartDate}
    onChange={(e) => setROCpmStartDate(e.target.value)}
  />
</TableCell>
<TableCell align="center">
  <DateInput
    value={ROCpmEndDate}
    onChange={(e) => setROCpmEndDate(e.target.value)}
  />
</TableCell>
<TableCell align="center">
  {isROCpmGenerated ? (
    <Button
      type="submit"
      variant="contained"
      onClick={downloadROCpmCSV}
    >
      {loadingROCpm ? (
        <CircularProgress size="1.53rem" />
      ) : (
        "Download CSV"
      )}
    </Button>
  ) : (
    <Button
      type="submit"
      variant="contained"
      onClick={generateROCpmCSV}
      disabled={disableROCpmButton}
    >
      {loadingROCpm ? (
        <CircularProgress size="1.53rem" />
      ) : (
        "Generate CSV"
      )}
    </Button>
  )}
  {/* {role === "ADMIN" ? (
    <Button onClick={getRegionsCode}>{renderFilter()}</Button>
  ) : (
    ""
  )} */}
</TableCell>
</TableRow>


               <TableRow>
                  <TableCell> 10 </TableCell>
                  <TableCell align="left">COR Report RO Daily</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={OptReportROStartDate}
                      onChange={(e) => setOptReportROStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={OptReportROEndDate}
                      onChange={(e) => setOptReportROEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {isOptReportROGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadCallOptimizedReportRO}
                        // disabled={disableLeadsButton}
                      >
                        {loadingOptReportRO ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generateCallOptimizedReportRO}
                        disabled={disableOptReportROButton}
                      >
                        {loadingOptReportRO ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell> 11 </TableCell>
                  <TableCell align="left">CIP Data Report</TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={SOSummaryStartDate}
                      onChange={(e) => setSOSummaryStartDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <DateInput
                      value={SOSummaryEndDate}
                      onChange={(e) => setSOSummaryEndDate(e.target.value)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    {isSOSummaryGenerated ? (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={downloadSOSummary}
                        disabled={disableSOSummaryButton}
                      >
                        {loadingSOSummary ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Download CSV"
                        )}
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={generateSOSummary}
                        disabled={disableSOSummaryButton}
                      >
                  
                        {loadingSOSummary ? (
                          <CircularProgress size="1.53rem" />
                        ) : (
                          "Generate CSV"
                        )}
                      </Button>
                    )} 
                  </TableCell>
                </TableRow>
      


                </TableBody>
            </Table>
            </TableContainer>
          </SectionCard>
        </>
      )}
    </>
  );
};






const VisitDownload = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN", "ZTM"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default VisitDownload;
